import api from "@/services/axios";

import type { AuthResponse, RequestOtpPayload, VerifyOtpPayload, VerifyOtpResponse } from "./type";

export async function requestOtp(payload: RequestOtpPayload): Promise<AuthResponse> {
  const { data } = await api.post("/api/v1/auth/otp/request", payload);

  return data;
}

export async function verifyOtp(payload: VerifyOtpPayload): Promise<VerifyOtpResponse> {
  const { data } = await api.post<{ data: VerifyOtpResponse }>("/api/v1/auth/otp/verify", payload);

  return data.data;
}

export async function logout(): Promise<AuthResponse> {
  const { data } = await api.post("/api/v1/auth/logout");

  return data;
}
